import React from 'react';
import { withRouter, Route, Switch, Redirect  } from 'react-router-dom'

import EtlPackageListComponent from './Components/Containers/EtlPackages/List';
import EtlPackageEditComponent from './Components/Containers/EtlPackages/Edit';
import ProviderIndexContainer from './Components/Containers/Providers/Index';
import DatalakeIndexContainer from './Components/Containers/Datalake/Index';
import AdvertiserIndexContainer from './Components/Containers/Advertisers/Index';
import WebsiteIndexContainer from './Components/Containers/Websites/Index';
import CampaignsIndexContainer from './Components/Containers/Campaigns/Index';
import ChannelIndexContainer from './Components/Containers/Channels/Index';
import UserIndexContainer from './Components/Containers/Users/Index';
import RoleIndexContainer from './Components/Containers/Roles/Index';
import BacklogContainer from './Components/Containers/Backlog/Index';
import HomeIndexContainer from './Components/Containers/Home/Index';

class AppRouting extends React.Component {
    render() { 
        return (
        <Switch>
            <Route path='/data-tools/etl-packages/list' render={routeProps => { return(<EtlPackageListComponent {...this.props} {...routeProps} />) }} />
            <Route path='/data-tools/etl-packages/:id/v:version/manage' render={routeProps => { return(<EtlPackageEditComponent {...this.props} {...routeProps} />) }} />
            <Route path='/data-tools/providers' render={routeProps => { return(<ProviderIndexContainer {...this.props} {...routeProps} />) }} />
            <Route path='/data-lake/explorer' render={routeProps => { return(<DatalakeIndexContainer {...this.props} {...routeProps} />) }} />
            <Route path='/organisations/advertisers' render={routeProps => { return(<AdvertiserIndexContainer {...this.props} {...routeProps} />) }} />
            <Route path='/organisations/websites' render={routeProps => { return(<WebsiteIndexContainer {...this.props} {...routeProps} />) }} />
            <Route path='/media/campaigns' render={routeProps => { return(<CampaignsIndexContainer {...this.props} {...routeProps} />) }} />
            <Route path='/data-classifications/channels' render={routeProps => { return(<ChannelIndexContainer {...this.props} {...routeProps} />) }} />
            <Route path='/system/users' render={routeProps => { return(<UserIndexContainer {...this.props} {...routeProps} />) }} />
            <Route path='/system/roles' render={routeProps => { return(<RoleIndexContainer {...this.props} {...routeProps} />) }} />
            <Route path='/agile-tools/backlog' render={routeProps => { return(<BacklogContainer {...this.props} {...routeProps} />) }} />
            <Route path='/' render={routeProps => { 
                if(routeProps.location.pathname !== '/') return(<Redirect from={routeProps.location.pathname} to="/" />);
                return(<HomeIndexContainer {...this.props} {...routeProps} />) 
            }} />
        </Switch>
        );
    }
}

export default withRouter(AppRouting);


// WEBPACK FOOTER //
// ./src/AppRouting.js